import PageTypes from './page_types';

/**
 * Page provider
 */
class PageTypeFactory {
    static isCart($container) {
        return $container.hasClass('cart');
    }

    static isGuide($container) {
        return $container.hasClass('guides');
    }

    static isCheckout($container) {
        return $container.hasClass('checkout');
    }

    static isSeries($container) {
        return $container.hasClass('series');
    }

    static isContact($container) {
        return $container.hasClass('cms') && ($container.find('h1').text().indexOf('faq') === 0);
    }

    static isCareers($container) {
        return $container.hasClass('careers');
    }

    static isFittingStation($container) {
        return $container.hasClass('fittingstation');
    }

    static isFittingStationSignUp($container) {
        return $container.hasClass('fittingstation') && $container.find('.fittingstation-signup').length;
    }

    static isBlog($container) {
        return $container.hasClass('blog');
    }

    static isNewsletterSignup($container) {
        return $container.hasClass('signup');
    }

    static isIndex($container) {
        return $container.hasClass('index');
    }

    static isProduct($container) {
        return $container.hasClass('product');
    }

    static isTyreShopsStation($container) {
        return $container.hasClass('tyreshops');
    }

    static isCatalog($container) {
        return $container.hasClass('catalog');
    }

    static getPageType($container) {
        if (!$container) {
            $container = $('.page-container');
        }

        if (PageTypeFactory.isIndex($container)) {
            return PageTypes.INDEX_PAGE;
        }

        if (PageTypeFactory.isProduct($container)) {
            return PageTypes.PRODUCT_PAGE;
        }

        if (PageTypeFactory.isTyreShopsStation($container)) {
            return PageTypes.TYRESHOPS_PAGE;
        }

        if (PageTypeFactory.isCatalog($container)) {
            return PageTypes.CATALOG_PAGE;
        }

        if (PageTypeFactory.isCart($container)) {
            return PageTypes.CART_PAGE;
        }

        if (PageTypeFactory.isGuide($container)) {
            return PageTypes.GUIDES_PAGE;
        }

        if (PageTypeFactory.isCheckout($container)) {
            return PageTypes.CHECKOUT_PAGE;
        }

        if (PageTypeFactory.isSeries($container)) {
            return PageTypes.SERIES_PAGE;
        }

        if (PageTypeFactory.isContact($container)) {
            return PageTypes.CONTACT_PAGE;
        }

        if (PageTypeFactory.isCareers($container)) {
            return PageTypes.CAREER_PAGE;
        }

        if (PageTypeFactory.isFittingStationSignUp($container)) {
            return PageTypes.FITTING_PARTNER_PAGE;
        }

        if (PageTypeFactory.isFittingStation($container)) {
            return PageTypes.FITTING_STATION_PAGE;
        }

        if (PageTypeFactory.isNewsletterSignup($container)) {
            return PageTypes.NEWSLETTER_SIGNUP_PAGE;
        }

        if (PageTypeFactory.isBlog($container)) {
            return PageTypes.BLOG_PAGE;
        }

        return PageTypes.PAGE;
    }
}

export default PageTypeFactory;